import React from 'react';
import { VIEWS, getTShirtImage } from '../../../config/productImages';

const VIEW_INSTRUCTIONS = {
  front: 'Add your design to the front of the shirt',
  back: 'Add your design to the back of the shirt',
  left: 'Add your design to the left shoulder/sleeve',
  right: 'Add your design to the right shoulder/sleeve',
};

export const ViewThumbnails = ({ view, colorId, viewDesignCounts, isTransitioning, onViewChange }) => (
  <>
    <div className="flex justify-center gap-3 sm:gap-3 mt-4 px-2">
      {VIEWS.map((v) => (
        <button
          key={v}
          data-testid={`view-${v}-btn`}
          onClick={() => onViewChange(v)}
          disabled={isTransitioning}
          className={`relative w-[72px] h-[88px] sm:w-20 sm:h-24 rounded-xl overflow-hidden transition-all duration-200 touch-manipulation ${
            view === v
              ? 'ring-3 ring-primary shadow-lg scale-105 bg-primary/5'
              : 'border-2 border-gray-200 hover:border-primary/50 hover:shadow-md active:scale-95 active:bg-gray-50 bg-white'
          } ${isTransitioning ? 'opacity-50 cursor-not-allowed' : ''}`}
          style={{ minWidth: '72px', minHeight: '88px' }}
        >
          <img
            src={getTShirtImage(colorId, v)}
            alt={`${v} view`}
            className="w-full h-full object-contain p-1.5"
          />
          {viewDesignCounts[v] > 0 && (
            <div className="absolute top-1 right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center shadow-sm">
              <span className="text-[10px] font-bold text-white">{viewDesignCounts[v]}</span>
            </div>
          )}
          <span className={`absolute bottom-0 left-0 right-0 text-xs font-bold text-center py-2 ${
            view === v ? 'bg-primary text-white' : 'bg-gray-100 text-gray-700'
          }`}>
            {v.charAt(0).toUpperCase() + v.slice(1)}
          </span>
        </button>
      ))}
    </div>
    <p className="text-xs text-gray-500 text-center mt-3">{VIEW_INSTRUCTIONS[view]}</p>
  </>
);

export default ViewThumbnails;
